import React, { Fragment } from "react";
import {
  CharacteristicsItems,
  CharacteristicsTitle,
} from "@/bit/components/next13.components.characteristics";
import { StepListItems } from "@/bit/components/next13.components.step-list";
import SimplePhone from "@/bit/components/next13.components.simple-phone";

const Banner = ({ bannerInfo, phone, className }) => {
  return (
    <>
      {bannerInfo[0]?.component === "characteristics" &&
        Array.isArray(bannerInfo) &&
        bannerInfo.map((bannerItem, i) => (
          <Fragment key={`key-${i}`}>
            <CharacteristicsTitle
              {...bannerItem}
              className={className}
              index={i}
            />
            <CharacteristicsItems
              {...{ ...bannerItem, layout: "tarifas" }}
              className={className}
              index={i}
            />
            {i < bannerInfo.length - 1 && <div className="banner-gap" />}
          </Fragment>
        ))}
      {bannerInfo?.component === "stepList" && (
        <StepListItems {...bannerInfo} className={className} />
      )}
      {phone && (
        <div className={className}>
          <SimplePhone {...phone} />
        </div>
      )}
    </>
  );
};

export default Banner;
